module.exports = "/packs/media/images/Family_7-dd5a8ae79934c5b84fba0766f7f8d4d7.png";